import globals from '../../utils/globals'

const UserName = ({ user, extraClass = '', children = null }) => {
  const rankClasses = rank => rank
    ? `
  ${rank.isBold ? 'rank--bold' : ''}
  ${rank.isItalic ? 'rank--italic' : ''}
  ${rank.isUnderline ? 'rank--underlined' : ''}
  ` : ''

  if (user.id && user.name && !user.url) {
    user.url = `/members/${user.name.toLowerCase()}-${user.id}`
  }

  return (
    user.id
      ? <span>
        <a className={`link--user ${rankClasses(user.rank)} ${extraClass || ''}`}
          style={{
            color: user.rank
              ? user.rank.color
              : ''
          }}
          href={globals('application') !== 'control'
            ? user.url
            : `/member/profile?userid=${user.id}`}>
          {user.name}
        </a>
        {
          children.length ? <span style={{ color: user.rank?.color || 'inherit' }}>{ children }</span> : null
        }
      </span>
      : <div class='link--user default-cursor'>{user.name}</div>
  )
}

export default UserName
